export default "__VITE_ASSET__BeeKxyyV__"